// Theme management
export const themeManager = {
    init() {
        // Check for saved theme preference, otherwise use system preference
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme) {
            this.setTheme(savedTheme === 'dark');
        } else {
            // Check system preference
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            this.setTheme(prefersDark);
        }

        // Listen for system theme changes
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
            if (!localStorage.getItem('theme')) {
                this.setTheme(e.matches);
            }
        });
    },

    setTheme(isDark) {
        // Set dark class on document element
        if (isDark) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
        
        // Update theme-dependent elements
        this.updateThemeDependentElements(isDark);
        
        // Save theme preference
        localStorage.setItem('theme', isDark ? 'dark' : 'light');
    },

    toggleTheme() {
        const isDark = !this.isDarkMode();
        this.setTheme(isDark);
        return isDark;
    },

    isDarkMode() {
        return document.documentElement.classList.contains('dark');
    },

    updateThemeDependentElements(isDark) {
        // Update meta theme-color
        const metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (!metaThemeColor) {
            const meta = document.createElement('meta');
            meta.name = 'theme-color';
            document.head.appendChild(meta);
        }
        document.querySelector('meta[name="theme-color"]').content = isDark ? '#111827' : '#F9FAFB';

        // Update any elements that need special handling
        const elements = document.querySelectorAll('[data-theme]');
        elements.forEach(element => {
            const themeValue = element.getAttribute('data-theme');
            if (themeValue === 'auto') {
                if (isDark) {
                    element.classList.add('dark');
                } else {
                    element.classList.remove('dark');
                }
            }
        });
    }
}; 